<script lang="ts">
  import { push } from "svelte-spa-router";
	import { ApiService } from "../services/api.service";
	import BlueButton from "../organisms/BlueButton.svelte";
	import ErrorMessage from "../atoms/ErrorMessage.svelte";
  import TextInput from "../atoms/forms/TextInput.svelte";
	import SmallBoard from "../molecules/SmallBoard.svelte";
	import Link from "../atoms/Link.svelte";

  let username = ''
	let isError = false
	let errorMessage = ''

  const handleUsername = (event) => username = event.detail.value

	const resetPassword = async () => {
		if (username === '') {
			isError = true
			errorMessage = 'ユーザー名は必須です。'
			return
		}

		const client = ApiService.createClient()
		try {
		  const { data } = await client.post('/user/password/reset', {
		  	username
		  })
			console.log(data)
			alert('パスワードを再発行しました。メールをご確認ください。')
			push('/login')
		} catch (e) {
			alert('エラーが発生しました。管理者にお問い合わせください。')
		}
	}
</script>

<SmallBoard title={process.env.APP_NAME}>
	<TextInput inputType="text" placeholder="ユーザー名"  isError={isError} on:input={handleUsername} klass="mt-10"/>

	<div class="mt-4">
		<ErrorMessage message={errorMessage} center />
	</div>

	<BlueButton click={resetPassword} klass="mt-3" full={true}>
		パスワードの再発行
	</BlueButton>

	<Link url="/login" klass="text-sm">
		ログイン画面
	</Link>
</SmallBoard>